angular.module("warsApp.controllers").controller('confirmationModalController', ['$scope', '$modalInstance', 'title', 'message', 'heading', function ($scope, $modalInstance, title, message, heading) {

    $scope.message = message;
    $scope.title = title;
    $scope.heading = heading;

    $scope.yesClicked = function () {
        $modalInstance.close();
    };

    $scope.noClicked = function () {
        $modalInstance.dismiss('cancel');
    };
}]);